import AUPPSRRenewForm from "modules/new-applications/components/application-actions/PPSRRegister/PPSRRenewForm/AUPPSRRenewForm";
import NZPPSRRenewForm from "modules/new-applications/components/application-actions/PPSRRegister/PPSRRenewForm/NZPPSRRenewForm";

export { AUPPSRRenewForm };
export { NZPPSRRenewForm };
